export default "__VITE_ASSET__CTXRvsdF__"